import { useTranslation } from "react-i18next";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";
import { useMemo } from "react";

type SubjectUpdatedPaymentMethodDescriptionDetails = {
  payment_iban_old: string;
  payment_iban_new: string;
  payment_type: string;
};

interface ISubjectUpdatedAddressDescritpionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectUpdatedPaymentMethodDescription = ({
  modifyDetailsJson,
}: ISubjectUpdatedAddressDescritpionProps) => {
  const { t } = useTranslation();

  const getPaymentTypeLabel = (code: string): string => {
    const translations: Record<string, string> = {
      A: t("payment_type-A"),
      B: t("payment_type-B"),
    };

    return translations[code] || code;
  };

  const subjectUpdatedPaymentMethodDescriptionDetails: SubjectUpdatedPaymentMethodDescriptionDetails =
    useMemo(() => {
      return {
        payment_iban_old:
          modifyDetailsJson.find((_) => _.key === "payment_iban-old")?.value ??
          "",
        payment_iban_new:
          modifyDetailsJson.find((_) => _.key === "payment_iban-new")?.value ??
          "",
        payment_type: getPaymentTypeLabel(
          modifyDetailsJson.find((_) => _.key === "payment_type")?.value ?? ""
        ),
      };
    }, [modifyDetailsJson, t]);

  return (
    <>
      {t("HISTORY-TEMPLATES.policy-subject-modified-payment-method-description", {
        payment_iban_old: subjectUpdatedPaymentMethodDescriptionDetails.payment_iban_old,
        payment_iban_new: subjectUpdatedPaymentMethodDescriptionDetails.payment_iban_new,
        payment_type: subjectUpdatedPaymentMethodDescriptionDetails.payment_type,
      })}
    </>
  );
};
export default SubjectUpdatedPaymentMethodDescription;
